const capabilities = {
    app: ['loader', 'paginator', 'filter', 'sorter', 'exporter', 'importer', 'error-logger'],
    entity: ['safe-deleter']
};

export default capabilities;
